const burger = document.querySelector('.burger');
const menu = document.querySelector('.header__top');

burger.addEventListener('click', () => {
  burger.classList.toggle('burger--active');
  menu.classList.toggle('header__top--active');
});
